import { IElectionRO } from '@/api/interfaces/IElection'
import { UiTheme } from '@/api/types/user'
import ColorThief from 'colorthief'

export const getVoteBackground = (election: IElectionRO) => {
  return `linear-gradient(to bottom, #${election.backgroundColor.slice(
    1,
  )}4D, #${election.backgroundColor.slice(1)}0F)`
}

export const getVersusVoteBackground = (
  election: IElectionRO,
  theme?: UiTheme,
) => {
  return `linear-gradient(to bottom, #${election.backgroundColor.slice(
    1,
  )}4D, #${election.backgroundColor.slice(1)}00)`
}

export const getVoteGaugeBackground = (election: IElectionRO) => {
  const color = election.backgroundColor || '#cccccc'

  return `linear-gradient(to left, #${color.slice(1)}, #${color.slice(1)}00)`
}

const componentToHex = (c: number) => {
  var hex = c.toString(16)
  return hex.length == 1 ? '0' + hex : hex
}

const rgbToHex = (r: number, g: number, b: number) => {
  return '#' + componentToHex(r) + componentToHex(g) + componentToHex(b)
}

export const getImagePointColorGradient = (
  image: HTMLElement | null,
): string => {
  const colorThief = new ColorThief()
  if (!image) {
    return ''
  }

  const img = image as HTMLImageElement

  try {
    const rgb = colorThief.getColor(img)
    return rgbToHex(rgb[0], rgb[1], rgb[2])
  } catch (e) {
    return ''
  }
}
